export default __webpack_public_path__ + "static/media/logo.973c1aa4.png";